var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "40px" } }, [
    _c("div", { staticClass: "m-footer" }, [
      _vm._v(
        "\n    国家首批区块链信息服务商备案号：渝网信备50011219179454790019号\n    "
      ),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isInDingTalk,
              expression: "isInDingTalk"
            }
          ]
        },
        [
          _vm._v(
            "服务备案号：渝ICP备14003483号-21X 主体备案号：渝ICP备14003483号"
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dae0805", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dae0805","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/myfooter/index.vue
// module id = uLC4
// module chunks = 2 3 6 8 15 16 18 19 20 21 22 25 37 72 73 159